import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import { isImage } from '../../helpers/isImage'

import { UploadIcon } from './icons'
import FileItem from './FileItem'

const UploadFiles = forwardRef(({mode = 'edit'}, ref) => {
  const { t } = useTranslation()

  const fileInputRef = useRef(null)

  const [files, setFiles] = useState([])

  useImperativeHandle(ref, () => ({
    getFiles: () => files,
    setFiles: (newFiles) => setFiles(prev => [...prev, ...newFiles]),
    hasAttachments: () => files.length > 0 && files.some(file => !isImage(file.type)),
    hasPhotos: () => files.length > 0 && files.some(file => isImage(file.type)),
  }))

  const handleUploadClick = () => {
    fileInputRef.current.click()
  }

  const handleUpload = (event) => {
    const files = [...event.target.files]
    setFiles(prev => [...prev, ...files])
  }

  const handleRemoveFile = (index) => (file) => {
    setFiles(prev => prev.filter((_, i) => i !== index))
  }

  return (
    <div className={styles.container}>
      {
        mode === 'edit'
          ? <div className={styles.uploadButton} onClick={handleUploadClick}>
              <input
                ref={fileInputRef}
                type="file"
                id="fileUpload"
                style={{display: 'none'}}
                onChange={handleUpload}
                multiple />
              <UploadIcon />
              <div className={styles.uploadButtonTitle}>{t('Upload the files')}</div>
            </div>
          : null
      }
      <div className={styles.files}>
        {
          files.map((file, i) => {
            return (
              <FileItem
                key={i}
                file={file}
                mode={mode}
                onRemove={handleRemoveFile(i)} />
            )
          })
        }
      </div>
    </div>
  )
})

export default UploadFiles
